export default {
    AUTH_TYPE: {
      EUDO_API: "x-auth",
      SPECIF: "s-auth",
    }
  }
  